import { Box as ChakraBox, BoxProps as ChakraBoxProps } from "@chakra-ui/react";

export const Box = ChakraBox;
export type BoxProps = ChakraBoxProps;
